import { TrashSimple } from '@phosphor-icons/react';

export default TrashSimple;
